var $54b47fc030b7b21e$exports = {};
// Set by the hero-sound block below; lets the fullscreen showreel handler
// restore the scroll-driven hero volume instead of hard-muting.
let $54b47fc030b7b21e$var$syncHeroAudio = ()=>{};
// Also set by the hero-sound block: reports whether the visitor has turned
// sound on with the hero's "son on/off" switch. The site starts silent, and
// the fullscreen showreel asks before unmuting, so it stays silent there too
// until the switch is flipped.
let $54b47fc030b7b21e$var$heroSoundAllowed = ()=>false;
// How long the cursor-following "cliquer pour agrandir" hint stays on screen
// before fading out on its own.
const $54b47fc030b7b21e$var$HINT_VISIBLE_MS = 2000;
// Gallery images are lazy-loaded at low resolution (`data-src` points into
// `img/low/`); the full-size file waits in `data-full-src` until the image is
// opened fullscreen, which is the only place the extra pixels are visible.
// Runs once per element — the attribute is dropped as soon as it is used.
// Gallery videos are not paired this way; they load a single file.
function $54b47fc030b7b21e$var$loadFullResolution(container) {
    container.querySelectorAll("[data-full-src]").forEach((el)=>{
        const full = el.getAttribute("data-full-src");
        el.removeAttribute("data-full-src");
        if (!full || el.getAttribute("src") === full) return;
        el.setAttribute("src", full);
    });
}
// Drops every project image/video out of fullscreen. Shared by the Esc key and
// the burger menu, which must never open on top of a fullscreen medium.
function $54b47fc030b7b21e$var$closeFullscreenMedia() {
    document.querySelectorAll(".project-image-container.active").forEach((el)=>el.classList.remove("active"));
}
// Burger Menu Toggle
document.addEventListener("DOMContentLoaded", ()=>{
    const burgerMenu = document.querySelector(".home-burger-menu");
    const navMenu = document.querySelector(".nav-menu");
    const body = document.body;
    if (burgerMenu && navMenu) {
        burgerMenu.addEventListener("click", ()=>{
            $54b47fc030b7b21e$var$closeFullscreenMedia();
            burgerMenu.classList.toggle("active");
            navMenu.classList.toggle("active");
            body.classList.toggle("menu-open");
        });
        // Close menu when clicking on a nav link
        const navLinks = document.querySelectorAll(".nav-menu-item a");
        navLinks.forEach((link)=>{
            link.addEventListener("click", ()=>{
                burgerMenu.classList.remove("active");
                navMenu.classList.remove("active");
                body.classList.remove("menu-open");
            });
        });
        // Close menu when clicking outside
        document.addEventListener("click", (e)=>{
            if (!burgerMenu.contains(e.target) && !navMenu.contains(e.target) && navMenu.classList.contains("active")) {
                burgerMenu.classList.remove("active");
                navMenu.classList.remove("active");
                body.classList.remove("menu-open");
            }
        });
    }
});
// Video Comparison Slider - Reusable Class
class $54b47fc030b7b21e$var$VideoComparisonSlider {
    constructor(container){
        this.container = container;
        if (!this.container) {
            console.warn(`VideoComparisonSlider: Container not found`);
            return;
        }
        // Query elements relative to this container
        this.slider = this.container.querySelector(".video-comparison-slider");
        this.overlay = this.container.querySelector(".video-comparison-overlay");
        this.mainVideo = this.container.querySelector(".video-comparison-main");
        this.secondaryVideo = this.container.querySelector(".video-comparison-secondary");
        if (!this.slider || !this.container) {
            console.warn(`VideoComparisonSlider: Required elements not found in container`);
            return;
        }
        this.init();
    }
    init() {
        this.setupEventListeners();
        this.syncVideos();
    }
    setupEventListeners() {
        this.slider.addEventListener("mousemove", (e)=>this.handleMouseMove(e));
        this.slider.addEventListener("mouseleave", ()=>this.handleMouseLeave());
        this.slider.addEventListener("mouseenter", ()=>this.handleMouseEnter());
        // Touch support for mobile
        this.slider.addEventListener("touchstart", (e)=>this.handleTouchStart(e), {
            passive: true
        });
        this.slider.addEventListener("touchmove", (e)=>this.handleTouchMove(e), {
            passive: true
        });
        this.slider.addEventListener("touchend", ()=>this.handleTouchEnd());
    }
    handleMouseMove(e) {
        const containerRect = this.slider.getBoundingClientRect();
        const mouseX = e.clientX - containerRect.left;
        const percentageX = mouseX / containerRect.width * 100;
        // Clamp between 0 and 100
        const clampedPercentage = Math.max(0, Math.min(100, percentageX));
        // Update the overlay clip-path
        this.overlay.style.clipPath = `inset(0 ${100 - clampedPercentage}% 0 0)`;
    }
    handleMouseLeave() {
        // Reset overlay opacity on mouse leave
        this.overlay.style.opacity = "0";
    }
    handleMouseEnter() {
        // Set opacity on mouse enter
        this.overlay.style.opacity = "1";
    }
    handleTouchStart(e) {
        this.overlay.style.opacity = "1";
        this.updateFromTouch(e);
    }
    handleTouchMove(e) {
        this.updateFromTouch(e);
    }
    handleTouchEnd() {
        this.overlay.style.opacity = "0";
    }
    updateFromTouch(e) {
        if (!e.touches || !e.touches.length) return;
        const touch = e.touches[0];
        const containerRect = this.slider.getBoundingClientRect();
        const touchX = touch.clientX - containerRect.left;
        const percentageX = touchX / containerRect.width * 100;
        const clampedPercentage = Math.max(0, Math.min(100, percentageX));
        this.overlay.style.clipPath = `inset(0 ${100 - clampedPercentage}% 0 0)`;
    }
    syncVideos() {
        if (!this.mainVideo || !this.secondaryVideo) return;
        if (typeof this.mainVideo.play !== "function") return;
        const OFFSET = 0.15;
        const MAX_DRIFT = 0.12;
        const align = ()=>{
            this.secondaryVideo.currentTime = this.mainVideo.currentTime + OFFSET;
        };
        // Both videos are lazy-loaded (data-src -> src), so wait until each one
        // actually has data before aligning them and starting them together.
        const startTogether = ()=>{
            if (this.mainVideo.readyState < 2 || this.secondaryVideo.readyState < 2) return;
            align();
            this.mainVideo.play().catch(()=>{});
            this.secondaryVideo.play().catch(()=>{});
        };
        this.mainVideo.addEventListener("loadeddata", startTogether);
        this.secondaryVideo.addEventListener("loadeddata", startTogether);
        startTogether();
        // Independent <video> elements drift apart over time; nudge the secondary
        // back onto the main one whenever the gap gets noticeable.
        setInterval(()=>{
            if (this.mainVideo.readyState < 2 || this.secondaryVideo.readyState < 2) return;
            const drift = this.secondaryVideo.currentTime - (this.mainVideo.currentTime + OFFSET);
            if (Math.abs(drift) > MAX_DRIFT) align();
        }, 2000);
    }
}
// Initialize all video comparison sliders
document.addEventListener("DOMContentLoaded", ()=>{
    const comparisonSections = document.querySelectorAll(".video-comparison");
    comparisonSections.forEach((section)=>{
        new $54b47fc030b7b21e$var$VideoComparisonSlider(section);
    });
});
// Toggle .active on .project-images when clicked
document.addEventListener("DOMContentLoaded", ()=>{
    const projectImages = document.querySelectorAll(".project-image-container");
    projectImages.forEach((el)=>{
        // Every gallery item gets its own close button, styled to only show while
        // the item is fullscreen. Built here rather than in project.html so it
        // covers images, videos and comparison sliders alike.
        const close = document.createElement("button");
        close.type = "button";
        close.className = "project-image-close";
        close.setAttribute("aria-label", "Fermer");
        close.innerHTML = '<span aria-hidden="true">&#10005;</span>';
        close.addEventListener("click", (e)=>{
            // The container itself toggles fullscreen on click — this button only
            // ever closes, so the click must not reach it.
            e.stopPropagation();
            el.classList.remove("active");
        });
        el.appendChild(close);
        el.addEventListener("click", ()=>{
            const opening = !el.classList.contains("active");
            el.classList.toggle("active");
            // Fetch the full-size file the moment it becomes worth showing.
            if (opening) $54b47fc030b7b21e$var$loadFullResolution(el);
        });
    });
});
document.addEventListener("keydown", (e)=>{
    if (e.key === "Escape" || e.key === "Esc" || e.keyCode === 27) $54b47fc030b7b21e$var$closeFullscreenMedia();
});
// Lazy load media when .project sections enter viewport
document.addEventListener("DOMContentLoaded", ()=>{
    const projects = document.querySelectorAll(".project");
    const observerOptions = {
        root: null,
        rootMargin: "50px",
        threshold: 0.1
    };
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                // Find all elements with data-src within this project
                const elementsWithDataSrc = entry.target.querySelectorAll("[data-src]");
                elementsWithDataSrc.forEach((element)=>{
                    const dataSrc = element.getAttribute("data-src");
                    if (!dataSrc) return;
                    // <object> (the documentaire PDF) points at its file with `data`,
                    // not `src` — setting `src` on it would do nothing at all.
                    const attr = element.tagName === "OBJECT" ? "data" : "src";
                    element.setAttribute(attr, dataSrc);
                });
                // Stop observing this project after loading
                observer.unobserve(entry.target);
            }
        });
    }, observerOptions);
    projects.forEach((project)=>{
        observer.observe(project);
    });
});
// The hero's "Voir le showreel" button: the only way into the fullscreen
// showreel. It sits centred in the hero (see home.scss) — the hero itself is
// no longer clickable, so the burger, the sound switch and the title are all
// reachable without a stray click opening the video.
document.addEventListener("DOMContentLoaded", ()=>{
    const button = document.querySelector(".home-showreel-button");
    if (!button) return;
    const playShowreel = ()=>{
        // Prefer the high-quality video, fall back to the low-quality one.
        const video = document.querySelector(".home-background-video.hq") || document.querySelector(".home-background-video");
        if (!video) return;
        // Entering without sound (or flipping the switch off) means the showreel
        // stays silent here too — fullscreen is not a way around that choice.
        const withSound = $54b47fc030b7b21e$var$heroSoundAllowed();
        video.muted = !withSound;
        if (withSound) video.volume = 1;
        video.controls = true;
        video.currentTime = 0;
        const request = video.requestFullscreen || video.webkitRequestFullscreen || video.webkitEnterFullscreen;
        if (request) request.call(video).catch(()=>{});
        video.play().catch(()=>{});
    };
    // Hide the controls once fullscreen is exited and hand the audio back to
    // the scroll-driven fade (which re-mutes unless the visitor accepted sound).
    const onFullscreenChange = ()=>{
        if (document.fullscreenElement || document.webkitFullscreenElement) return;
        document.querySelectorAll(".home-background-video").forEach((v)=>{
            v.controls = false;
        });
        $54b47fc030b7b21e$var$syncHeroAudio();
    };
    document.addEventListener("fullscreenchange", onFullscreenChange);
    document.addEventListener("webkitfullscreenchange", onFullscreenChange);
    button.addEventListener("click", playShowreel);
});
// "Click to enlarge" hint that follows the cursor while hovering a gallery
// item — shown only until the user clicks an item for the first time.
document.addEventListener("DOMContentLoaded", ()=>{
    const items = document.querySelectorAll(".project-image-container");
    if (!items.length) return;
    let hintDismissed = false;
    const hint = document.createElement("div");
    hint.className = "gallery-hint";
    hint.textContent = "cliquer pour agrandir";
    document.body.appendChild(hint);
    const isMobile = ()=>window.innerWidth <= 768;
    let hideTimer = null;
    // Same self-hiding behaviour as the showreel label: once it has timed out it
    // stays hidden until the pointer leaves the item and hovers one again.
    let timedOut = false;
    const hideHint = ()=>{
        clearTimeout(hideTimer);
        timedOut = false;
        hint.classList.remove("visible");
    };
    const showHint = (e)=>{
        if (hintDismissed || isMobile()) return;
        hint.style.left = `${e.clientX}px`;
        hint.style.top = `${e.clientY}px`;
        if (timedOut || hint.classList.contains("visible")) return;
        hint.classList.add("visible");
        clearTimeout(hideTimer);
        hideTimer = setTimeout(()=>{
            timedOut = true;
            hint.classList.remove("visible");
        }, $54b47fc030b7b21e$var$HINT_VISIBLE_MS);
    };
    items.forEach((el)=>{
        el.addEventListener("mousemove", showHint);
        el.addEventListener("mouseleave", hideHint);
        el.addEventListener("click", ()=>{
            // Stop showing the hint once any item has been clicked.
            hintDismissed = true;
            hideHint();
        }, {
            once: false
        });
    });
});
// Custom cursor — a small green dot with a very short fading trail, drawn on
// a fullscreen canvas. Desktop-only: touch devices keep native behaviour, and
// the native cursor is only hidden (see _cursor.scss) under the same media
// query, so there's never a missing cursor.
document.addEventListener("DOMContentLoaded", ()=>{
    if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;
    const CURSOR_COLOR = "rgb(0, 90, 0)"; // darker than $green, solid — the
    // trail fades by shrinking, never by opacity.
    const DOT_RADIUS = 6;
    const TRAIL_MS = 150;
    // Hard cap on the trail's length. Without it a fast flick smears an 80ms
    // history over several hundred pixels, which is what made quick movements
    // look bad — past this the tail stops growing and just follows.
    const TRAIL_MAX_PX = 1000;
    // The trail is redrawn each frame from this many evenly-spaced nodes, so
    // the taper is distributed along the *distance* travelled rather than per
    // raw sample — the spacing no longer depends on pointer speed.
    const TRAIL_NODES = 128;
    // Dot and trail swell with pointer speed: 1x at rest, up to MAX_SCALE once
    // the pointer is moving at SPEED_AT_MAX_SCALE or faster.
    const MAX_SCALE = 3;
    const SPEED_AT_MAX_SCALE = 4600; // px per second
    // Per-frame easing of that scale, expressed at 60fps and normalised to the
    // real frame time below — without it the size would snap around frame to
    // frame, since raw pointer speed is very noisy.
    const SCALE_EASE = 0.14;
    const canvas = document.createElement("canvas");
    canvas.className = "custom-cursor-canvas";
    document.body.appendChild(canvas);
    const ctx = canvas.getContext("2d");
    // The canvas backing store has to be sized in *device* pixels, or on a
    // retina display the whole trail is drawn at half resolution and upscaled
    // — which is most of why the edges looked rough.
    const resize = ()=>{
        const dpr = window.devicePixelRatio || 1;
        canvas.style.width = `${window.innerWidth}px`;
        canvas.style.height = `${window.innerHeight}px`;
        canvas.width = Math.round(window.innerWidth * dpr);
        canvas.height = Math.round(window.innerHeight * dpr);
        // Setting .width/.height resets the transform, so re-apply it after.
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    };
    resize();
    window.addEventListener("resize", resize);
    let points = [];
    // Kept separately so the dot stays exactly under the pointer, and stays put
    // once the trail behind it has fully aged out and emptied the array.
    let current = null;
    let visible = false;
    // True while the pointer sits over an <iframe>/<object>/<embed>, where this
    // document stops receiving pointer events entirely (see below).
    let overEmbed = false;
    // Eased speed-driven size multiplier, and the timestamp it was last eased
    // at (so the easing rate is the same on a 60Hz and a 120Hz display).
    let scale = 1;
    let lastFrame = performance.now();
    // The YouTube <iframe> heroes and the <object> PDF viewer are each a
    // SEPARATE document. Pointer events that happen inside one are dispatched
    // in that document and never reach this window, so the dot would otherwise
    // freeze at the embed's edge while the real cursor moves around inside it.
    // There is no fix for that — YouTube is cross-origin and the PDF viewer is
    // the browser's own, so neither can be listened to or styled from here.
    // What we can do is hand over cleanly: hide the dot on the way in and let
    // the embed show its native cursor, which its controls need anyway.
    const EMBED_SELECTOR = "iframe, object, embed";
    const updateOverEmbed = (target)=>{
        overEmbed = target instanceof Element && target.closest(EMBED_SELECTOR) !== null;
    };
    // Crossing onto an embed fires pointerover on the embed element itself (it
    // is a normal element in THIS document) — the last event we get before the
    // pointer disappears into the nested document.
    document.addEventListener("pointerover", (e)=>updateOverEmbed(e.target), {
        passive: true
    });
    // getCoalescedEvents() hands back the browser/OS's full-rate sample
    // history rather than the one position per frame `mousemove` reports, so
    // the path is dense even during a fast flick.
    //
    // The history is stored in PAGE coordinates (client + scroll) so the trail
    // is anchored to the document and scrolls away with the content, like ink
    // on the page. `current` stays in viewport coordinates — the dot has to
    // track the physical pointer, which scrolling does not move. The two are
    // reconciled in `draw` below.
    window.addEventListener("pointermove", (e)=>{
        visible = true;
        updateOverEmbed(e.target);
        const events = typeof e.getCoalescedEvents === "function" ? e.getCoalescedEvents() : [
            e
        ];
        (events.length ? events : [
            e
        ]).forEach((ev)=>{
            points.push({
                x: ev.clientX + window.scrollX,
                y: ev.clientY + window.scrollY,
                t: ev.timeStamp
            });
        });
        current = {
            x: e.clientX,
            y: e.clientY
        };
    }, {
        passive: true
    });
    // Scrolling moves the pointer through the document without firing a single
    // pointermove, so without this the newest stored point would be left behind
    // on the page and the trail would bridge the gap with one long straight
    // streak. Recording the cursor's page position as the page moves keeps the
    // path continuous — and means a scroll draws a trail of its own.
    window.addEventListener("scroll", ()=>{
        if (!current || overEmbed) return;
        points.push({
            x: current.x + window.scrollX,
            y: current.y + window.scrollY,
            t: performance.now()
        });
    }, {
        passive: true
    });
    document.addEventListener("mouseleave", ()=>{
        visible = false;
    });
    // Walks `path` from the cursor backwards and returns `count` points spaced
    // evenly by arc length, stopping at `maxLength`. Even spacing is what lets
    // the taper below be smooth at any speed.
    const resample = (path, count, maxLength)=>{
        const cum = [
            0
        ];
        for(let i = 1; i < path.length; i++)cum.push(cum[i - 1] + Math.hypot(path[i].x - path[i - 1].x, path[i].y - path[i - 1].y));
        const total = Math.min(cum[cum.length - 1], maxLength);
        if (total < 1) return null;
        const out = [];
        let seg = 1;
        for(let n = 0; n < count; n++){
            const target = total * n / (count - 1);
            while(seg < path.length - 1 && cum[seg] < target)seg++;
            const span = cum[seg] - cum[seg - 1];
            const f = span > 0 ? (target - cum[seg - 1]) / span : 0;
            out.push({
                x: path[seg - 1].x + (path[seg].x - path[seg - 1].x) * f,
                y: path[seg - 1].y + (path[seg].y - path[seg - 1].y) * f
            });
        }
        return out;
    };
    // Pointer speed in px/s, measured over the whole retained history rather
    // than between the last two samples — individual samples are far too noisy
    // to drive a size off. Returns 0 once the history has aged out, which is
    // what shrinks the cursor back down when the pointer stops.
    //
    // This is speed through the PAGE, not the viewport, so scrolling counts as
    // movement and swells the cursor too — consistent with the trail, which
    // scrolling also draws. Measure `points` against the live scroll offset
    // instead if you ever want the swell to ignore scrolling.
    const pointerSpeed = ()=>{
        if (points.length < 2) return 0;
        const span = points[points.length - 1].t - points[0].t;
        if (span < 8) return 0;
        let dist = 0;
        for(let i = 1; i < points.length; i++)dist += Math.hypot(points[i].x - points[i - 1].x, points[i].y - points[i - 1].y);
        return dist / (span / 1000);
    };
    // Fills the trail as ONE tapered polygon. It used to be a stack of
    // individually-stroked round-capped segments, and at speed their widths
    // differed enough from one to the next that the silhouette came out beaded
    // and lumpy. Offsetting each node along its normal and filling the outline
    // in a single path gives a continuous taper instead.
    const fillTrail = (nodes, headRadius)=>{
        const last = nodes.length - 1;
        const left = [];
        const right = [];
        for(let i = 0; i <= last; i++){
            const prev = nodes[Math.max(0, i - 1)];
            const next = nodes[Math.min(last, i + 1)];
            const tx = next.x - prev.x;
            const ty = next.y - prev.y;
            const len = Math.hypot(tx, ty);
            if (len < 0.0001) continue; // degenerate: no direction to offset along
            const radius = headRadius * (1 - i / last);
            const nx = -ty / len * radius;
            const ny = tx / len * radius;
            left.push({
                x: nodes[i].x + nx,
                y: nodes[i].y + ny
            });
            right.push({
                x: nodes[i].x - nx,
                y: nodes[i].y - ny
            });
        }
        if (left.length < 3) return;
        // Both edges are drawn as quadratics through their midpoints so any
        // residual angle between nodes is rounded off. Smoothing the *outline*
        // (rather than the sampled path, as an earlier version did) leaves the
        // head geometry alone, so the tip no longer changes direction a frame
        // after it is drawn.
        const tail = left.length - 1;
        ctx.beginPath();
        ctx.moveTo(left[0].x, left[0].y);
        for(let i = 1; i < tail; i++)ctx.quadraticCurveTo(left[i].x, left[i].y, (left[i].x + left[i + 1].x) / 2, (left[i].y + left[i + 1].y) / 2);
        ctx.lineTo(left[tail].x, left[tail].y);
        ctx.lineTo(right[tail].x, right[tail].y);
        for(let i = tail - 1; i >= 1; i--)ctx.quadraticCurveTo(right[i].x, right[i].y, (right[i].x + right[i - 1].x) / 2, (right[i].y + right[i - 1].y) / 2);
        ctx.lineTo(right[0].x, right[0].y);
        ctx.closePath();
        ctx.fill();
    };
    const draw = ()=>{
        requestAnimationFrame(draw);
        const now = performance.now();
        // Clamped so a backgrounded tab doesn't come back with one huge step.
        const dt = Math.min(now - lastFrame, 100);
        lastFrame = now;
        points = points.filter((p)=>now - p.t <= TRAIL_MS);
        // Grow with speed, ease back down when the pointer slows or stops. The
        // easing factor is converted from its 60fps value to this frame's real
        // length, so the swell feels identical whatever the refresh rate.
        const target = 1 + (MAX_SCALE - 1) * Math.min(pointerSpeed() / SPEED_AT_MAX_SCALE, 1);
        scale += (target - scale) * (1 - Math.pow(1 - SCALE_EASE, dt / (1000 / 60)));
        const radius = DOT_RADIUS * scale;
        ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
        if (!visible || !current) return;
        ctx.fillStyle = CURSOR_COLOR;
        // Newest first: the trail is built from the cursor backwards in time.
        // The stored points are in page coordinates, so they are converted back
        // to the viewport here — that subtraction is what makes the trail travel
        // with the content when the page scrolls. `current` is already a viewport
        // position, so the path's head lands exactly on the dot.
        const sx = window.scrollX;
        const sy = window.scrollY;
        const path = [
            current
        ];
        for(let i = points.length - 1; i >= 0; i--)path.push({
            x: points[i].x - sx,
            y: points[i].y - sy
        });
        if (path.length > 1) {
            const nodes = resample(path, TRAIL_NODES, TRAIL_MAX_PX);
            if (nodes) fillTrail(nodes, radius);
        }
        // The dot itself: always drawn at the last known position, even once the
        // trail behind it has fully faded — so it never disappears while the
        // pointer is simply sitting still. Same radius as the trail's head, so it
        // caps that flat edge and the join stays seamless as the size changes.
        //
        // The one exception is an embed, where the pointer is no longer being
        // reported and the dot would just sit frozen at the boundary. Only the
        // dot is suppressed: the trail is left to drain away on its own over
        // TRAIL_MS rather than popping out of existence.
        if (overEmbed) return;
        ctx.beginPath();
        ctx.arc(current.x, current.y, radius, 0, Math.PI * 2);
        ctx.fill();
    };
    requestAnimationFrame(draw);
});
// Hero sound. The site starts silent; the "son off/on" switch in the hero is
// the only way to turn sound on. Once on, the volume is driven by scroll,
// reaching silence once the hero has left the viewport.
document.addEventListener("DOMContentLoaded", ()=>{
    const home = document.querySelector(".home");
    const heroVideos = document.querySelectorAll(".home-background-video");
    if (!heroVideos.length) return;
    let soundAllowed = false;
    // The HQ video replaces the LQ one as soon as it has data; only the one
    // actually on screen should ever be audible, the other stays silent.
    const activeHero = ()=>{
        const hq = document.querySelector(".home-background-video.hq");
        if (hq && hq.readyState >= 2) return hq;
        return document.querySelector(".home-background-video:not(.hq)");
    };
    // Volume tracks how much of the hero is still on screen: full at the top of
    // the page, silent by the time it has scrolled away.
    const applyHeroVolume = ()=>{
        // Don't fight the fullscreen showreel, which manages its own audio.
        const fullscreen = document.fullscreenElement || document.webkitFullscreenElement;
        if (fullscreen && fullscreen.classList.contains("home-background-video")) return;
        const height = home && home.offsetHeight || window.innerHeight;
        const scrolled = window.scrollY || window.pageYOffset || 0;
        const progress = Math.min(Math.max(scrolled / height, 0), 1);
        const volume = soundAllowed ? 1 - progress : 0;
        const active = activeHero();
        heroVideos.forEach((video)=>{
            const audible = video === active && volume > 0.01;
            video.volume = audible ? volume : 0;
            video.muted = !audible;
        });
    };
    $54b47fc030b7b21e$var$syncHeroAudio = applyHeroVolume;
    $54b47fc030b7b21e$var$heroSoundAllowed = ()=>soundAllowed;
    window.addEventListener("scroll", applyHeroVolume, {
        passive: true
    });
    window.addEventListener("resize", applyHeroVolume);
    // The LQ→HQ handover changes which video should be audible.
    heroVideos.forEach((video)=>video.addEventListener("loadeddata", applyHeroVolume));
    // Small switch in the hero's top-left corner. Flipping it changes what the
    // scroll fade is allowed to play.
    const soundToggle = document.querySelector(".home-sound-toggle");
    const syncSoundToggle = ()=>{
        if (!soundToggle) return;
        soundToggle.textContent = soundAllowed ? "son on" : "son off";
        soundToggle.classList.toggle("muted", !soundAllowed);
        soundToggle.setAttribute("aria-pressed", String(soundAllowed));
        soundToggle.setAttribute("aria-label", soundAllowed ? "Couper le son du showreel" : "Activer le son du showreel");
    };
    if (soundToggle) soundToggle.addEventListener("click", (e)=>{
        // The hero opens the fullscreen showreel on click — not from here.
        e.stopPropagation();
        soundAllowed = !soundAllowed;
        syncSoundToggle();
        applyHeroVolume();
        if (soundAllowed) // Unmuting is allowed here because we are inside a user gesture.
        heroVideos.forEach((video)=>video.play().catch(()=>{}));
    });
    applyHeroVolume();
    syncSoundToggle();
});
// Page transition — a green wipe between the site's own pages. Clicking an
// internal link slides a green panel up over the screen, then navigates; the
// next page starts covered (see the inline script in each page's <head>) and
// the panel carries on upward to reveal it. The panel itself is html::after,
// styled in _page-transition.scss. Must match $page-transition-duration.
const $54b47fc030b7b21e$var$PAGE_TRANSITION_MS = 600;
const $54b47fc030b7b21e$var$reducedMotion = ()=>window.matchMedia("(prefers-reduced-motion: reduce)").matches;
// Slides the green panel up until it covers the screen; resolves once it has.
function $54b47fc030b7b21e$var$coverScreen() {
    const root = document.documentElement;
    if ($54b47fc030b7b21e$var$reducedMotion()) return Promise.resolve();
    root.classList.remove("pt-enter", "pt-reveal");
    root.classList.add("pt-leave");
    return new Promise((resolve)=>setTimeout(resolve, $54b47fc030b7b21e$var$PAGE_TRANSITION_MS));
}
// From a covered screen, carries the panel on upward and off the top.
function $54b47fc030b7b21e$var$uncoverScreen() {
    const root = document.documentElement;
    root.classList.remove("pt-leave");
    root.classList.add("pt-enter");
    // Two frames so the covered state is painted before the slide starts.
    requestAnimationFrame(()=>requestAnimationFrame(()=>{
            root.classList.add("pt-reveal");
            setTimeout(()=>root.classList.remove("pt-enter", "pt-reveal"), $54b47fc030b7b21e$var$PAGE_TRANSITION_MS);
        }));
}
(()=>{
    const root = document.documentElement;
    // Arriving from another page through the wipe: the <head> script has
    // already covered the screen.
    try {
        sessionStorage.removeItem("page-transition");
    } catch (e) {}
    if (root.classList.contains("pt-enter")) $54b47fc030b7b21e$var$uncoverScreen();
    // Coming back through the browser's back button can restore the old page
    // from cache exactly as it was left — fully covered. Wipe it open again.
    window.addEventListener("pageshow", (e)=>{
        if (e.persisted && root.classList.contains("pt-leave")) $54b47fc030b7b21e$var$uncoverScreen();
    });
    document.addEventListener("click", (e)=>{
        const link = e.target.closest("a[href]");
        if (!link || $54b47fc030b7b21e$var$reducedMotion() || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || link.target && link.target !== "_self" || link.hasAttribute("download") || link.origin !== location.origin) return;
        // Same-page anchors (the nav menu, the back-to-top arrow) just scroll.
        if (link.pathname === location.pathname && link.hash) return;
        // Files (the CV PDF) are not pages.
        if (!/(\/|\.html)$/.test(link.pathname)) return;
        e.preventDefault();
        try {
            sessionStorage.setItem("page-transition", "1");
        } catch (err) {}
        $54b47fc030b7b21e$var$coverScreen().then(()=>{
            location.href = link.href;
        });
    });
})();
// No dragging images out of the page, nor the links that wrap them (the
// album and poster covers). CSS `-webkit-user-drag` in _base.scss handles
// Chrome and Safari; this catches Firefox and the wrapping links.
document.addEventListener("dragstart", (e)=>{
    const target = e.target;
    if (target instanceof Element && (target.matches("img, video") || target.querySelector("img, video"))) e.preventDefault();
});


//# sourceMappingURL=index.21b58cbf.js.map
